import { X } from "lucide-react";
import { MultiSelect } from "@/components/MultiSelect";

const union = (listed, counts) => [
  ...new Set([...(listed || []), ...Object.keys(counts || {}).filter(Boolean)]),
];

/** Unit · Project Type · Status — each offers only what still holds something to fix. */
export const InconsistencySlicers = ({ data, meta, plant, type, status, setParam }) => {
  const facets = data.facets || {};
  const units = data.units || [];
  const names = Object.fromEntries((meta?.plants || []).map((p) => [p.code, p.name]));
  // Only what the portal actually honoured — a unit outside the officer's scope is not a pick.
  const any = Object.values(data.picked || {}).some((v) => v.length);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="incon-slicers">
      {(data.work_units || []).length > 1 && (
        <MultiSelect
          label="Unit"
          testId="incon-filter-plant"
          width="w-[150px]"
          value={plant}
          onChange={(v) => setParam("plant", v)}
          counts={facets.plant}
          options={units.map((u) => ({
            value: u.plant,
            label: u.plant,
            hint: `${names[u.plant] || u.name} · ${u.unclean} to fix, ${u.open} entries`,
          }))}
        />
      )}
      <MultiSelect
        label="Project Type"
        testId="incon-filter-type"
        width="w-[190px]"
        value={type}
        onChange={(v) => setParam("type", v)}
        counts={facets.project_type}
        options={union(meta?.project_types, facets.project_type).map((t) => ({
          value: t,
          label: t,
        }))}
      />
      <MultiSelect
        label="Status"
        testId="incon-filter-status"
        width="w-[190px]"
        value={status}
        onChange={(v) => setParam("status", v)}
        counts={facets.status}
        options={union((meta?.status_views || []).map((s) => s.key), facets.status).map((s) => ({
          value: s,
          label: s,
        }))}
      />
      {any && (
        <button
          type="button"
          data-testid="incon-clear-slicers"
          onClick={() => setParam("", "")}
          className="inline-flex h-11 items-center gap-1.5 border border-border bg-card px-3 font-display text-[10px] font-bold uppercase tracking-widest transition-colors duration-200 hover:bg-muted"
        >
          <X className="h-3.5 w-3.5" /> Clear slicers
        </button>
      )}
    </div>
  );
};
